/** Auto-generated ID prefix for select group headers that don't have explicit IDs */
export const BTSelectGroupHeaderId = "selectGroupAutoId";
